import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import UnPostedTransactionData from "./UnPostedTransactionData";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import { handleGetRequest } from "../../services/GetTemplate";
import { useHistory } from "react-router-dom";

function UnPostedTransaction() {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [data, setData] = useState(null);

  let history = useHistory();

  const validationSchema = Yup.object().shape({
    fromData: Yup.date()
      .nullable()
      .max(Yup.ref("toData"), "From Date cannot be greater than To Date."), // This line ensures fromDate is not greater than toDate
    toData: Yup.date()
      .nullable()
      .min(Yup.ref("fromData"), "To Date cannot be lesser than From Date."), // This line ensures toDate is not lesser than fromDate
    batchId: Yup.string().required()
      .matches(/^[1-9][0-9]*$/, "Please enter a numeric value greater than 0")
      .nullable(),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fromData: "",
      toData: "",
      batchId: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");

        const res = await handleGetRequest(
          `zbizgateway/fileStatusCheck/getUnpostedTransactions?fromDate=${data?.fromData || ""
          }&toDate=${data?.toData || ""}&batchId=${data?.batchId || ""} `
        );
        setData(res.data);
      } catch (err) {
        console.log(err);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <>
      <div className="page_header">
        <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div className="d_align">
            <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
            <h3 className="mod_heading">Un Posted Transactions</h3>
          </div>
        </div>
      </div>
      <div className="card Card__Round">
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="From Date"
                  keyName="fromData"
                  {...props}
                />
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="To Date"
                  keyName="toData"
                  {...props}
                />
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="text"
                  label="Batch Id"
                  keyName="batchId"
                  {...props}
                />
              </div>
            </div>
          </div>

          <div className="GenerateDown__Btn p-mt-4">
            <Button
              disabled={loading}
              label="View"
              className="Btn__Transparent"
            />
          </div>
        </form>
      </div>
      <UnPostedTransactionData data={data} />
    </>
  );
}

export default UnPostedTransaction;
